// extracted by css-extract-rspack-plugin
module.exports =  {"lost-password-modal":"LostPassword-pz6T__lost-password-modal","forgot-input":"LostPassword-zmWI__forgot-input","help-container":"LostPassword-xtyR__help-container"};